module.exports = __webpack_public_path__ + "img/DSC_0154.14e3dee7.jpg";